import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

interface ICustomPieChart {
  data: { name: string; value: number }[];
  colors: string[];
}

const RADIAN = Math.PI / 180;

// Customized label for each slice
const renderCustomizedLabel = (props: any) => {
  const { cx, cy, midAngle, innerRadius, outerRadius, percent } = props;

  // Hide label if slice is < 3%
  if (percent < 0.03) return null;

  // If the slice is very large (e.g., >= 95%), move label closer to center
  const isVeryLargeSlice = percent >= 0.95;

  // Adjust radius factor based on slice size
  const offsetFactor = isVeryLargeSlice ? 0.45 : 0.65;
  const radius = innerRadius + (outerRadius - innerRadius) * offsetFactor;

  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="middle"
      className="text-xs font-bold"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomPieChart = ({ data, colors }: ICustomPieChart) => {
  // 1) Calculate total of all slice values
  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        {/* 2) Main donut chart */}
        <Pie
          data={data}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius="50%"
          outerRadius="80%"
          labelLine={false}
          label={renderCustomizedLabel}
        >
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>

        {/* 3) Text in the center showing total */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-lg font-bold fill-current text-green-800"
        >
          {totalValue}
        </text>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CustomPieChart;
